import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { SEOHead } from "@/components/seo-head";
import { Home, Search, ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-background text-foreground px-6">
      <SEOHead
        title="Page Not Found"
        description="The page you're looking for doesn't exist. Browse gyms, find trainers, or head back to the homepage."
        canonicalPath="/404"
        noindex
      />

      <div className="max-w-lg w-full text-center">
        <div className="mb-8">
          <span
            className="text-8xl font-display font-bold text-primary/20"
            style={{ fontFamily: "'Bebas Neue', sans-serif", letterSpacing: "0.05em" }}
          >
            404
          </span>
        </div>

        <h1 className="text-3xl font-display font-bold text-white mb-3">
          Page Not Found
        </h1>
        <p className="text-white/50 mb-10 text-lg">
          Looks like this page tapped out. Let's get you back on the mat.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link href="/">
            <Button className="bg-primary text-primary-foreground hover:bg-primary/90 font-bold h-11 px-6 rounded-xl gap-2">
              <Home className="w-4 h-4" />
              Back to Home
            </Button>
          </Link>
          <Link href="/explore/gyms">
            <Button variant="outline" className="border-white/10 text-white/70 hover:text-white h-11 px-6 rounded-xl gap-2">
              <Search className="w-4 h-4" />
              Explore Gyms
            </Button>
          </Link>
        </div>

        <div className="mt-12 pt-8 border-t border-white/[0.06]">
          <p className="text-sm text-white/30">
            Looking for something specific? Try{" "}
            <Link href="/explore/trainers">
              <span className="text-primary/60 hover:text-primary cursor-pointer transition-colors">finding a trainer</span>
            </Link>{" "}
            or{" "}
            <Link href="/pricing">
              <span className="text-primary/60 hover:text-primary cursor-pointer transition-colors">checking our pricing</span>
            </Link>.
          </p>
        </div>
      </div>
    </div>
  );
}
